
import $ from 'jquery';
import _ from 'lodash';
import constants            from 'Constants';
import restMessages         from 'RestMessages';
import restService from 'RestService';
import Spinner              from 'spin/spin';
import zLib from "util/ZLib";
import XJService from "xml/XJService";
import listService from "./ListService";
import util                from 'util/Util';

//=====================================================================================================================
// REST request and response processing carried out here.
//
// (This is a split of RestService. This module has a debugger bundle map size below the limit for debugger mapping.}
//=====================================================================================================================

class RestServiceAux {


    addAsset(file, formId, newAsset, imgData, callback) {

        const form = new FormData();
        form.append('token', restService.token);
        form.append('files', file);
        form.append('fileMode', 0);
        form.append('mimeType', newAsset.get('mimeType'));
        form.append('formId', formId);
        form.append('imgData', imgData);

        const settings = {
            'async': true,
            'crossDomain': false,
            'url': `${restService.apiHostUrl}/Assets/Add`,
            'method': 'POST',
            "headers": {'cache-control': 'no-cache'},
            'processData': false,
            'contentType': false,
            'mimeType': 'multipart/form-data',
            'data': form,
            'dataType': 'JSON'
        };
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        $.ajax(settings).done(response => {

            const
                error = _.get(response, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                serverResponse = _.get(response, 'RESULT.RESPONSE');

            if (parseInt(errorCode) === 0 && serverResponse) {
                callback(false, response, newAsset);
            } else {
                restService.checkErrorCodeUserNotAuthenticated(errorCode);
                callback(error);
            }


        }).fail(function( jqxhr, textStatus, errorThrown ) {
            if( jqxhr.status === 0 ){
                $.ajax(this).done(response => {
                    const
                    error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
    
                    if (parseInt(errorCode) === 0 && serverResponse) {
                        callback(false, response, newAsset);
                    } else {
                        restService.checkErrorCodeUserNotAuthenticated(errorCode);
                        callback(error);
                    }
                }).fail((jqXHR, textStatus, errorThrown) => {
                    callback('failed', textStatus, newAsset);
                })
            }else{
                callback('failed', textStatus, newAsset);
            }
        }).always(() => {
            spinner.stop();
        });
    }


    /*======================================================================
     * Rest API call for retrieving private forms of the logged account.
     * ======================================================================
     * */
    getFormsByGroupType(groupTypeId, groupId = constants.DEFAULT_GROUP_ID) {

        const postParams = {
            token: restService.token,
            groupTypeId: groupTypeId,
            groupId: groupId,
            dataType: 'JSON'
        };
        const url = `${restService.apiHostUrl}/App/Browse`;

        return new Promise((resolve, reject) => {
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    message = _.get(error, 'MESSAGE', ''),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse) {
                    restService.token = response.RESULT.TOKEN;
                    resolve(response);
                } else {
                    restService.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }


    /*======================================================================
     * Rest API call for retrieving Dashboard Details Data.
     * ======================================================================
     * */
    getDashboardDetails(dashboardParams) {
        const defaultParams = {
            token: restService.getToken(),
            dataType: 'JSON',
            includeRecentPlayedForms: 'false',
            includeRecentPlayedReports: 'false',
            includeRecentManagedForms: 'false',
            includeRecentManagedReports: 'false',
            includeNotificationsTotals: 'false',
            includeNotifications: 'false',
            notificationsFromAttentionLevel: '0',
            notificationsToAttentionLevel: '0',
            includeAllPlayableForms: 'false',
            includeAllManagedForms: 'false',
            settingsXML: constants.DEFAULT_GROUP_ID

        };

        const paramsToSend = Object.assign({}, defaultParams, dashboardParams);
        let url = `${restService.apiHostUrl}/App/Dashboard`;
        let spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            $.post(url, paramsToSend).done(function (response) {
                spinner.stop();
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    restService.setToken(response.RESULT.TOKEN);
                    resolve(response);
                } else {
                    restService.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                spinner.stop();
                reject(errorThrown);
            });
        });

        return promise;

    }

    getFormFieldsPromise(formId, formGUID) {
        return new Promise((resolve, reject)=>{
            restService.getFormFields(formId, formGUID , (err, fields) => {
                if(err){
                    reject(err);
                } else {
                    resolve(fields);
                }
            });
        });
    }

    /*======================================================================
     * Rest API call for transferring form ownership.
     * ======================================================================
     * */
    transferFormOwner(formId, newOwnerUserId) {

        return new Promise((resolve, reject) => {
            const
                url = `${restService.apiHostUrl}/App/TransferFormOwner`,
                postParams = {
                    token: restService.getToken(),
                    formId: formId,
                    newOwnerUserId: newOwnerUserId,
                    dataType: 'JSON'
                };
            $.post(url, postParams).done(response => {
                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE'),
                    newToken = _.get(response, 'RESULT.TOKEN');

                restService.setToken(newToken);
                if (String(errorCode) === '0') {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    restService.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(restMessages.codeToMessage(errorCode));
                }
            }).fail(error => {
                console.log('transferFormOwner error: ', error);
                reject('Error transferring form ownership');
            });
        });
    }

    /*======================================================================
     * Rest API call for transferring report ownership.
     * ======================================================================
     * */
    transferReportOwner(reportId, newOwnerUserId) {
        return new Promise((resolve, reject) => {
            const
                // Note naming convention difference from its twin for forms:
                url = `${restService.apiHostUrl}/Report/TransferOwner`,
                postParams = {
                    token: restService.getToken(),
                    reportId: reportId,
                    newOwnerUserId: newOwnerUserId,
                    dataType: 'JSON'
                };

            $.post(url, postParams).done(response => {
                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE'),
                    newToken = _.get(response, 'RESULT.TOKEN');

                restService.setToken(newToken);
                if (String(errorCode) === '0') {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    restService.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(restMessages.codeToMessage(errorCode));
                }
            }).fail(error => {
                console.log('transferReportOwner error: ', error);
                reject('Error transferring report ownership');
            });
        });
    }

    /*====================================================================================================
     * Rest API call for retrieving actions by a given connection Id on a connect behavior component.
     * ===================================================================================================
     * */
    getParametersByActionIdAndConnectionId(actionId,
                                           connectionId,
                                           formId = constants.BEHAVIOR_CONNECTIONS_FORM_ID,
                                           purpose = constants.BEHAVIOR_CONNECTIONS_PURPOSE,
                                           detailsData = false) {


        const postParams = {
            token: restService.getToken(),
            connectionId: connectionId,
            actionId: actionId,
            formId: formId,
            purpose: purpose
        };

        const url = restService.apiHostUrl + '/Integration/GetAction',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        return new Promise((resolve, reject) => {
            const self = this;
            $.post(url, postParams).done(function (response) {
                spinner.stop();
                let responseForUI = {
                    sendParameters: [],
                    returnParameters: []

                };
                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse) {
                    const actions = response.RESULT.RESPONSE.ActionXML['#cdata-section'];
                    const result = util.minifyXMLString(zLib.decompressForm(actions));
                    console.log("Uncompressed Action",result);

                    const json = XJService.toJSON(result);
                    if(detailsData){
                        responseForUI={};
                        responseForUI.general = response.RESULT.RESPONSE;
                        responseForUI.details = json;
                        console.log("The action",json);
                    }
                    else{
                        responseForUI.actionType = json.Action._type;
                        responseForUI.sendParameters = json.Action.Send.Parameter instanceof Array ? json.Action.Send.Parameter : [json.Action.Send.Parameter];
                        responseForUI.returnParameters = json.Action.Receive.Parameter instanceof Array ? json.Action.Receive.Parameter : [json.Action.Receive.Parameter];
                    }
                    resolve(responseForUI);

                } else {
                    restService.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);

                }
                restService.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                spinner.stop();
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving actions by a given connection Id on a connect behavior component.
     * =============================================================================
     * */
    getActionsByConnectionId(connectionId,
                             formId = constants.BEHAVIOR_CONNECTIONS_FORM_ID,
                             purpose = constants.BEHAVIOR_CONNECTIONS_PURPOSE) {
        const that = restService;

        const postParams = {
            token: that.getToken(),
            connectionId: connectionId,
            formId: formId,
            purpose: purpose
        };


        const url = `${that.apiHostUrl}/Integration/BrowseActions`,
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        return new Promise((resolve, reject) => {

            $.post(url, postParams).done(function (response) {                
                spinner.stop();
                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    const actions = util.enforceArrayType(response.RESULT.RESPONSE.ActionList ? response.RESULT.RESPONSE.ActionList.Action : []);

                    // Set the token just if the post don't receive errors, to avoid get disconnected on multiple calls
                    that.setToken(response.RESULT.TOKEN);
                    listService.removePromiseInProgress(connectionId);
                    resolve(actions);
                } else if (parseInt(errorCode) === 2){
                    // Can be expected on a large input set. If it is a "read" error 2 it will manifest on the next call.
                    listService.removePromiseInProgress(connectionId);
                    reject(error);
                } else {
                    console.log(`===> ERROR: getActionsByConnectionId ${errorCode}`, response);
                    that.setToken(response.RESULT.TOKEN);
                    listService.removePromiseInProgress(connectionId);
                    that.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                spinner.stop();
                reject(errorThrown);
            });
        });
    }


}

const restServiceAux = new RestServiceAux();
export default restServiceAux;

